"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const ChatMessage_1 = require("./ChatMessage");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeRecord_1 = __importDefault(require("./deserializeRecord"));
const deserializeString_1 = require("./deserializeString");
function chatDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value, 'chat');
    return {
        messages: (0, unwrap_1.default)(object.messages, (0, deserializeRecord_1.default)(deserializeString_1.deserializeString, ChatMessage_1.chatMessageDeserializeWithoutId)),
    };
}
exports.chatDeserialize = chatDeserialize;
